import { UID, getColumns } from "./common";
import {
  TAX_ID_COLLECTION_TYPE_DESCRIPTION,
  TAX_ID_COLLECTION_TYPE
} from "utils/constants/taxRate";

export default {
  columns: getColumns({
    header: "Tax ids",
    subheader:
      "Enable collection and validation of tax ids as part of checkout. Choose between standard or international countries coverage."
  }),
  rows: [
    {
      title: {
        value: "Standard (extended Eurozone)",
        subtitle: "",
        tooltip:
          TAX_ID_COLLECTION_TYPE_DESCRIPTION[TAX_ID_COLLECTION_TYPE.STANDARD]
      },
      stripe: {
        uid: UID.STRIPE,
        enabled: false
      },
      priceblocs: {
        uid: UID.PRICEBLOCS,
        enabled: true
      }
    },
    {
      title: {
        value: "International",
        tooltip:
          TAX_ID_COLLECTION_TYPE_DESCRIPTION[
            TAX_ID_COLLECTION_TYPE.INTERNATIONAL
          ]
      },
      stripe: {
        uid: UID.STRIPE,
        enabled: false
      },
      priceblocs: {
        uid: UID.PRICEBLOCS,
        enabled: true
      }
    }
  ]
};
